import React from 'react';
import APicker from 'antd-mobile/lib/picker';



export default class Picker extends APicker {}